export const movies = [
  {
    id: "gp1001",
    title: "长夜将明",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20drama%20movie%20poster%2C%20lone%20silhouetted%20figure%20standing%20in%20a%20rain-soaked%20narrow%20alley%20at%20night%2C%20neon%20reflections%20on%20wet%20ground%2C%20moody%20deep%20red%20and%20dark%20tones%2C%20film%20noir%20atmosphere%2C%20high%20contrast%20dramatic%20lighting%2C%20mist%20in%20the%20air%2C%20portrait%20composition&width=400&height=600&seq=gp-film-01&orientation=portrait",
    category: "movie",
    type: "犯罪",
    region: "中国大陆",
    year: 2025,
    duration: "128分钟",
    director: "张承远",
    actors: ["段奕宏", "张颂文", "谭卓"],
    rating: 8.4,
    tags: ["犯罪", "悬疑", "现实题材"],
    summary: "一名老刑警在退休前夕接手一桩陈年悬案，随着调查深入，真相与人心一同浮出水面。",
    synopsis: "刑警老周在退休前的最后一个月，被调回重案组协助调查一桩搁置十二年的命案。案件当年的线索几乎全部断裂，唯一留下的是一段模糊的监控与一个无人认领的旧背包。老周带着年轻搭档一路追查，从城中村的老巷到废弃的工厂，逐渐拼凑出被时间掩埋的往事。当真相临近，他发现自己面对的不仅是凶手，还有当年所有选择沉默的人。影片以写实的镜头语言讲述小人物在漫长黑夜中的坚守，也让观众看到正义或许迟到但从不会缺席。"
  },
  {
    id: "gp1002",
    title: "山海归途",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20science%20fiction%20movie%20poster%2C%20astronaut%20silhouette%20gazing%20at%20a%20vast%20glowing%20mountain%20range%20under%20a%20swirling%20alien%20sky%2C%20cosmic%20dust%20and%20light%20beams%2C%20warm%20amber%20and%20deep%20red%20gold%20tones%2C%20grand%20cinematic%20scale%2C%20portrait%20composition&width=400&height=600&seq=gp-film-02&orientation=portrait",
    category: "movie",
    type: "科幻",
    region: "中国大陆",
    year: 2026,
    duration: "146分钟",
    director: "陆知远",
    actors: ["吴京", "倪妮", "李雪健"],
    rating: 8.7,
    tags: ["科幻", "灾难", "家国"],
    summary: "当远航的飞船与地球失去联系，一群航天人用最朴素的方式，踏上跨越星海的归途。",
    synopsis: "在人类首次深空载人任务中，探索飞船“山海号”遭遇未知的引力扰动，被迫偏离预定航线。面对能源告急与通讯中断，指令长陈默带领船员做出了一系列艰难抉择。与此同时，地面指挥中心的一群老航天人昼夜不眠，试图重建那一条几乎不可能的联络通道。影片将宏大的宇宙奇观与细腻的人物情感交织，讲述一群人为了回家而义无反顾的故事，也重新诠释了“归途”二字的分量。"
  },
  {
    id: "gp1003",
    title: "长安十二辰",
    cover: "https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20Tang%20dynasty%20historical%20drama%20poster%2C%20towering%20palace%20gates%20lit%20by%20hundreds%20of%20red%20lanterns%2C%20ornate%20roof%20tiles%20and%20golden%20decorations%2C%20warm%20amber%20light%2C%20imperial%20majesty%2C%20cinematic%20depth%2C%20portrait%20composition&width=400&height=600&seq=gp-film-03&orientation=portrait",
    category: "tv",
    type: "古装",
    region: "中国大陆",
    year: 2024,
    duration: "40集",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "热依扎"],
    rating: 8.9,
    tags: ["古装", "悬疑", "权谋"],
    summary: "上元节前夕的长安城暗流涌动，一个死囚与一位少年联手，要在十二个时辰内挽救整座城池。",
    synopsis: "上元节前夜，突厥狼卫潜入长安，谋划在灯会当日制造惊天危机。身陷囹圄的靖安司老吏被临时放出戴罪立功，与一位天资卓绝的少年携手展开追查。十二个时辰之内，他们穿梭于坊市、官署与暗巷之间，与看不见的敌人斗智斗勇。剧集以精良的服化道与紧凑的节奏还原盛唐气象，也刻画了小人物于危难之际挺身而出的担当。"
  },
  {
    id: "gp1004",
    title: "疾风行动",
    cover: "https://readdy.ai/api/search-image?query=High%20octane%20Hong%20Kong%20action%20movie%20poster%2C%20car%20chase%20with%20sparks%20and%20explosion%20on%20a%20crowded%20night%20street%2C%20blurred%20motion%20and%20flying%20debris%2C%20intense%20orange%20flames%20against%20dark%20city%20skyline%2C%20dramatic%20contrast%2C%20portrait%20composition&width=400&height=600&seq=gp-film-04&orientation=portrait",
    category: "movie",
    type: "动作",
    region: "中国香港",
    year: 2025,
    duration: "118分钟",
    director: "陈木胜",
    actors: ["古天乐", "刘青云", "彭于晏"],
    rating: 7.8,
    tags: ["动作", "警匪", "爆破"],
    summary: "一场横跨港岛与九龙的追捕行动，让警与匪在一夜之间立场互换。",
    synopsis: "重案组警司与一名卧底探员联手追踪一个跨国走私集团。行动当日却因内鬼泄密而全线崩盘，双方在闹市展开一场惊心动魄的追逐。枪火、飞车与爆破接连上演，曾经对立的两人不得不在绝境中彼此托付。影片以凌厉的剪辑和实景特技呈现港式动作片的硬核质感，也探讨了在灰色地带中如何守住底线。"
  },
  {
    id: "gp1005",
    title: "烟火人间",
    cover: "https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20drama%20movie%20poster%2C%20cozy%20steaming%20kitchen%20with%20steam%20rising%20from%20pots%2C%20soft%20afternoon%20sunlight%20through%20lace%20curtains%2C%20everyday%20objects%20and%20wooden%20table%2C%20gentle%20amber%20and%20cream%20tones%2C%20tender%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-05&orientation=portrait",
    category: "tv",
    type: "家庭",
    region: "中国大陆",
    year: 2023,
    duration: "36集",
    director: "沈严",
    actors: ["海清", "黄磊", "陶虹"],
    rating: 8.2,
    tags: ["家庭", "治愈", "烟火气"],
    summary: "一间开在老街的深夜小饭馆，串联起三代人的悲欢与这座城市最真实的温度。",
    synopsis: "故事围绕老城区一家经营了三十年的小饭馆展开。老板老陈守着一口老灶，迎来送往形形色色的客人。随着城市改造推进，老街面临拆迁，一家人与街坊邻里在去留之间做出各自的选择。剧集用一日三餐的烟火气，铺陈出平凡生活中的坚韧与温情，让观众在别人的故事里看到自己的影子。"
  },
  {
    id: "gp1006",
    title: "雾隐迷城",
    cover: "https://readdy.ai/api/search-image?query=Suspense%20mystery%20series%20poster%2C%20foggy%20old%20Chinese%20town%20with%20dim%20street%20lamps%20vanishing%20into%20dense%20mist%2C%20single%20figure%20walking%20down%20a%20narrow%20stone%20lane%2C%20cold%20gray%20with%20faint%20red%20glow%2C%20eerie%20atmosphere%2C%20portrait%20composition&width=400&height=600&seq=gp-film-06&orientation=portrait",
    category: "tv",
    type: "悬疑",
    region: "中国大陆",
    year: 2025,
    duration: "24集",
    director: "五百",
    actors: ["王景春", "秦昊", "马思纯"],
    rating: 8.5,
    tags: ["悬疑", "推理", "烧脑"],
    summary: "连续七起看似无关的失踪案，都指向小镇边缘那片终年不散的浓雾。",
    synopsis: "一座被浓雾笼罩的南方小镇，接连发生离奇失踪事件。外地调来的刑警与本地老警员组成搭档，从一张张被撕碎的照片和一本旧日记入手，逐步揭开小镇尘封多年的秘密。随着调查深入，每个人的动机都变得暧昧不清，真相像雾一样在眼前聚散。剧集以冷静克制的叙事营造出令人窒息的悬疑氛围。"
  },
  {
    id: "gp1007",
    title: "少年游",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20martial%20arts%20movie%20poster%2C%20young%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20cliff%20above%20clouds%2C%20ancient%20sword%20gleaming%2C%20pine%20trees%20and%20distant%20mountains%2C%20misty%20green%20and%20golden%20light%2C%20heroic%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-07&orientation=portrait",
    category: "movie",
    type: "武侠",
    region: "中国大陆",
    year: 2024,
    duration: "134分钟",
    director: "徐浩峰",
    actors: ["彭昱畅", "周也", "宋洋"],
    rating: 8.0,
    tags: ["武侠", "古装", "成长"],
    summary: "一个初入江湖的少年，背负师门重托，在刀光剑影中寻找属于自己的道。",
    synopsis: "少年阿游自幼在山中学剑，师父临终前交给他一封信，让他下山送往千里之外的旧友。一路上，他卷入江湖门派的恩怨与朝堂的暗流，从懵懂少年逐渐成长为能独当一面的剑客。影片以写意的山水画面与克制的动作设计，讲述了一个关于信念与成长的传统武侠故事。"
  },
  {
    id: "gp1008",
    title: "时光代理人",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20science%20fiction%20series%20poster%2C%20glowing%20circular%20time%20portal%20in%20a%20dark%20room%20with%20drifting%20clock%20fragments%2C%20silhouettes%20of%20two%20people%20reaching%20across%20the%20light%2C%20warm%20gold%20and%20deep%20crimson%20tones%2C%20dreamy%20ethereal%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-08&orientation=portrait",
    category: "tv",
    type: "爱情",
    region: "中国大陆",
    year: 2026,
    duration: "30集",
    director: "李慧珠",
    actors: ["杨幂", "白宇", "李现"],
    rating: 7.9,
    tags: ["科幻", "爱情", "时空"],
    summary: "两个能进入他人记忆的人，在一次委托中意外改变了过去，也改写了彼此的未来。",
    synopsis: "一家名为“时光代理人”的特殊机构，能够通过特殊装置进入他人的记忆，帮助委托人了却遗憾。能力出众的搭档在一次任务中，无意间触碰了时间的禁区，让原本平行的两条命运线开始交缠。他们在不断回溯的过程中，既要修补他人的人生，也要面对自己无法回避的选择。剧集将科幻设定与细腻情感巧妙融合。"
  },
  {
    id: "gp1009",
    title: "北纬三十度",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20adventure%20drama%20movie%20poster%2C%20hiker%20standing%20on%20a%20rocky%20ridge%20overlooking%20a%20deep%20green%20river%20valley%20and%20towering%20mountains%2C%20morning%20mist%2C%20dramatic%20sky%2C%20rich%20emerald%20and%20amber%20tones%2C%20epic%20journey%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-09&orientation=portrait",
    category: "movie",
    type: "冒险",
    region: "中国大陆",
    year: 2023,
    duration: "122分钟",
    director: "张杨",
    actors: ["黄轩", "王砚辉", "任素汐"],
    rating: 8.1,
    tags: ["冒险", "剧情", "纪录感"],
    summary: "为了寻找失踪多年的父亲，一位地质学者沿着北纬三十度线展开一场人生远行。",
    synopsis: "地质学者程远在整理父亲遗物时，发现了一本记录着神秘坐标的野外笔记。为了弄清父亲最后一次科考的真相，他独自踏上沿着北纬三十度线的旅程。途中他穿越雪山、峡谷与原始森林，遇见了形形色色的旅人，也逐渐理解了父亲当年的选择。影片以辽阔的自然景观与克制的叙事，探讨人与自然、亲情与和解的主题。"
  },
  {
    id: "gp1010",
    title: "笑看风云",
    cover: "https://readdy.ai/api/search-image?query=Bright%20cheerful%20Chinese%20comedy%20series%20poster%2C%20colorful%20modern%20office%20with%20confetti%20and%20office%20supplies%20flying%2C%20playful%20characters%20laughing%2C%20vivid%20orange%20yellow%20and%20white%20tones%2C%20upbeat%20energetic%20mood%2C%20clean%20studio%20background%2C%20portrait%20composition&width=400&height=600&seq=gp-film-10&orientation=portrait",
    category: "tv",
    type: "喜剧",
    region: "中国大陆",
    year: 2024,
    duration: "28集",
    director: "尚敬",
    actors: ["沈腾", "马丽", "常远"],
    rating: 7.6,
    tags: ["喜剧", "职场", "轻松"],
    summary: "一家濒临倒闭的文创公司里，一群“不靠谱”的员工决定最后一搏。",
    synopsis: "老牌文创公司因经营不善面临关门，老板跑路后留下五个性格迥异的员工。为了拿回被拖欠的工资，他们决定自掏腰包把公司盘下来，用最离谱的点子做最后一搏。从直播带货到社区活动，状况百出的创业日常笑料不断。剧集用轻松幽默的方式讲述普通人的坚持与友情，让人笑着笑着就被治愈。"
  },
  {
    id: "gp1011",
    title: "深海回声",
    cover: "https://readdy.ai/api/search-image?query=Deep%20sea%20suspense%20thriller%20movie%20poster%2C%20lone%20submersible%20descending%20into%20dark%20ocean%20abyss%20surrounded%20by%20faint%20bioluminescent%20particles%2C%20a%20distant%20glowing%20object%20below%2C%20deep%20teal%20and%20black%20with%20warm%20light%20beams%2C%20portrait%20composition&width=400&height=600&seq=gp-film-11&orientation=portrait",
    category: "movie",
    type: "悬疑",
    region: "中国大陆",
    year: 2025,
    duration: "116分钟",
    director: "路阳",
    actors: ["雷佳音", "张译", "辛芷蕾"],
    rating: 8.3,
    tags: ["悬疑", "科幻", "惊悚"],
    summary: "一支深海科考队在海沟深处捕捉到一段不属于任何已知生物的声音。",
    synopsis: "科考船“远望号”在勘探太平洋海沟时，记录到一段频率诡异的低频声波。为了查明来源，队长带领队员乘坐深潜器下潜到数千米的海底。在那里，他们发现了远超人类认知的存在，也唤醒了沉睡已久的恐惧。影片以受限空间与幽暗氛围营造出强烈的紧张感，探讨人类对未知的敬畏。"
  },
  {
    id: "gp1012",
    title: "都市迷航",
    cover: "https://readdy.ai/api/search-image?query=Urban%20drama%20series%20poster%2C%20lone%20figure%20walking%20through%20a%20vast%20glowing%20city%20skyline%20at%20night%2C%20towering%20buildings%20and%20street%20lights%2C%20a%20touch%20of%20rain%2C%20warm%20amber%20windows%20against%20dark%20facades%2C%20cinematic%20isolation%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-12&orientation=portrait",
    category: "tv",
    type: "都市",
    region: "中国香港",
    year: 2024,
    duration: "32集",
    director: "陈可辛",
    actors: ["梁朝伟", "周迅", "张颂文"],
    rating: 8.6,
    tags: ["都市", "情感", "群像"],
    summary: "五个生活在这座城市的陌生人，因为一场意外，命运在同一个夜晚交汇。",
    synopsis: "深夜的一场交通事故，让出租车司机、急诊科医生、独居老人、失业青年与一位企业高管的人生在同一个路口交汇。剧集以多线并行的方式，展现这座繁华都市背后每个人的孤独与渴望。看似毫无交集的他们，在一次次巧合中彼此影响，最终都找到了生活继续向前的理由。"
  },
  {
    id: "gp1013",
    title: "星火燎原",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20war%20drama%20poster%2C%20ragged%20soldiers%20marching%20under%20a%20dramatic%20sunset%20across%20a%20barren%20field%2C%20tattered%20flags%20and%20smoke%2C%20dust%20and%20ember%20sparks%2C%20muted%20earthy%20brown%20and%20red%20tones%2C%20solemn%20epic%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-13&orientation=portrait",
    category: "tv",
    type: "历史",
    region: "中国大陆",
    year: 2023,
    duration: "42集",
    director: "张黎",
    actors: ["李雪健", "张嘉益", "段奕宏"],
    rating: 9.0,
    tags: ["历史", "战争", "正剧"],
    summary: "从一支小小的队伍到燎原之势，一段波澜壮阔的岁月被重新讲述。",
    synopsis: "剧集以宏大的历史视野，讲述在艰苦卓绝的岁月里，一群普通人如何凭着坚定的信念走到一起，从星星之火发展成燎原之势。从行军打仗到根据地建设，从战场上的生死相托到生活中的相互扶持，每一个角色都有血有肉。作品以严谨的考据和扎实的表演，致敬那段不该被遗忘的历史。"
  },
  {
    id: "gp1014",
    title: "半城烟雨",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20love%20story%20movie%20poster%2C%20rainy%20old%20lane%20lined%20with%20wooden%20shops%20and%20paper%20umbrellas%2C%20two%20figures%20sharing%20one%20umbrella%20under%20soft%20rain%2C%20warm%20lantern%20glow%20and%20mist%2C%20tender%20nostalgic%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-14&orientation=portrait",
    category: "movie",
    type: "爱情",
    region: "中国台湾",
    year: 2024,
    duration: "112分钟",
    director: "陈正道",
    actors: ["许光汉", "周冬雨", "张子枫"],
    rating: 7.7,
    tags: ["爱情", "文艺", "治愈"],
    summary: "一场淅淅沥沥的春雨，让两代人的爱情在这座南方小城悄然重叠。",
    synopsis: "南方小城的雨季漫长而温柔。回乡整理老宅的青年，在泛黄的日记里读到了外婆年轻时的故事。同样的老街、同样的雨伞、同样的等待，两代人的爱情在时空里悄然重叠。影片以细腻的镜头与克制的对白，描绘出一段跨越岁月的深情，让人相信有些等待值得被铭记。"
  },
  {
    id: "gp1015",
    title: "代号·破晓",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20spy%20action%20movie%20poster%2C%20covert%20agent%20in%20a%20trench%20coat%20standing%20in%20a%20dim%20underground%20bunker%2C%20flickering%20lamps%20and%20coded%20papers%2C%20smoke%20and%20shadows%2C%20cold%20steel%20gray%20with%20striking%20red%20accents%2C%20tense%20thriller%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-15&orientation=portrait",
    category: "movie",
    type: "谍战",
    region: "中国大陆",
    year: 2026,
    duration: "132分钟",
    director: "麦兆辉",
    actors: ["张震", "廖凡", "宋佳"],
    rating: 8.2,
    tags: ["谍战", "动作", "悬疑"],
    summary: "黎明前最黑暗的时刻，一名潜伏者必须在身份暴露之前完成最后的传递。",
    synopsis: "战火未熄的年代，一名潜伏在敌人内部多年的情报员接到了一项几乎不可能完成的任务。他必须在黎明之前，将一份关乎全局的名单送出去，而身边熟悉的面孔随时可能变成致命的威胁。影片以紧凑的节奏与层层反转，刻画潜伏者在孤独与信仰之间的挣扎，也致敬那些无名英雄。"
  },
  {
    id: "gp1016",
    title: "小巷人家",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20family%20period%20drama%20poster%2C%20warm%20old%20neighborhood%20alley%20with%20bicycles%20and%20potted%20plants%2C%20afternoon%20sunlight%20on%20brick%20walls%2C%20laundry%20hanging%20on%20lines%2C%20gentle%20sepia%20and%20amber%20tones%2C%20cozy%20nostalgic%20mood%2C%20portrait%20composition&width=400&height=600&seq=gp-film-16&orientation=portrait",
    category: "tv",
    type: "年代",
    region: "中国大陆",
    year: 2022,
    duration: "34集",
    director: "张开宙",
    actors: ["闫妮", "蒋欣", "李光洁"],
    rating: 8.8,
    tags: ["年代", "家庭", "温情"],
    summary: "一条老巷子里几户人家的柴米油盐，映照出大时代里最动人的烟火与温情。",
    synopsis: "故事发生在上世纪八九十年代的一座南方小城，一条普通的老巷里住着几户人家。他们一同经历升学、就业、婚嫁与时代的变迁，有争执也有守望，有离别也有重逢。剧集用琐碎而真实的日常，还原那个年代的生活质感，让观众在怀旧中找到久违的温暖与感动。"
  }
];

export const movieRegions = ["中国大陆", "中国香港", "中国台湾"];
export const movieTypes = ["犯罪", "科幻", "古装", "动作", "家庭", "悬疑", "武侠", "爱情", "冒险", "喜剧", "都市", "历史", "谍战", "年代"];
export const movieYears = [2026, 2025, 2024, 2023, 2022];